module.exports = __webpack_public_path__ + "e900e5c525f20db4dc21a44ca53723c5.png";